import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import MedicalMotionGraphic from "./components/MedicalMotionGraphic";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MedicalMotionGraphic />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;